export const numberFormats = {
  "fr-FR": {
    maximumSignificantDigits: 15,
  },
  "en-EN": {
    maximumSignificantDigits: 15,
  },
};
